export default __webpack_public_path__ + "static/lab_neodyme-d6bf955b590ab15f5c0ba732005e4326.jpg";